// ==========================================
// Home.jsx - Dashboard / Welcome Page
// ==========================================

import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import styles from "../assets/styles/Home.module.css";

function Home() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleStartIdeation = () => {
    navigate("/product-details");
  };

  return (
    <div className={styles.homeContainer}>
      <div className={styles.animationBackground}></div>
      <div className={styles.welcomeBox}>
        <h1 className={styles.welcomeTitle}>
          Welcome, {user?.username || 'User'}! 👋
        </h1>
        <p className={styles.welcomeSubtitle}>
          Ready to create amazing product designs with AI?
        </p>
        
        <div className={styles.actionCard}>
          <h2>Start Your Form Ideation!</h2>
          <p>Generate AI-powered product concept renderings</p>
          <button 
            onClick={handleStartIdeation}
            className={styles.startButton}
          >
            Start Ideation →
          </button>
        </div>

        <div className={styles.featuresGrid}>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>🎨</div>
            <h3>AI-Powered Design</h3>
            <p>Generate unique product concepts with advanced AI</p>
          </div>
          
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>✨</div>
            <h3>Stylistic Phrases</h3>
            <p>Select stylistic phrases to guide the AI</p>
          </div>
          
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>🖼️</div>
            <h3>Gallery</h3>
            <p>View and manage all your generated designs</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
